/** Публичные пути юридических документов платформы Бай.Спорт */

/**
 * Документы, галочки согласия и ссылки на /legal/*.
 * Реквизиты — в LEGAL_OPERATOR (legalDocuments.js).
 */
export const LEGAL_PUBLIC_ENABLED = true;

export const LEGAL_PATHS = {
  offer: "/legal/offer",
  privacy: "/legal/privacy",
  cookies: "/legal/cookies",
  payments: "/legal/payments",
  clientConsent: "/legal/client-consent",
  ownerConsent: "/legal/owner-consent",
};

export const LEGAL_DOC_IDS = [
  "offer",
  "privacy",
  "cookies",
  "payments",
  "clientConsent",
  "ownerConsent",
];
